<template>
  <v-dialog v-model="showDialog" max-width="70vw" persistent no-click-animation>
    <v-card width="70vw">
      <v-toolbar :elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>金額項目情報編集</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <div class="description">ここでは金額項目の使用する／しない、及び表示名の変更が行えます。</div>
          <v-divider />
          <v-tabs v-model="tab" slider-color="primary" slider-size="3">
            <v-tab href="#tab1" class="text-black-bold">頻出項目</v-tab>
            <v-tab href="#tab2" class="text-black-bold">課税項目</v-tab>
            <v-tab href="#tab3" class="text-black-bold">非課税項目</v-tab>
            <v-tab href="#tab4" class="text-black-bold">内税項目</v-tab>
            <v-tab href="#tab5" class="text-black-bold">汎用項目</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="tab1">
              <p style="white-space:pre-wrap;"></p>
              <!-- 見出し行 -->
              <v-row no-gutters align-content="center" style="color:#1F2B38;background-color:#E3E3E3;">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">定義名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">使用判断</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">表示名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">集計区分</span></v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">基本運賃（課税）</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.kihonUnchinShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.kihonUnchinTitle"
                        ref="kihonUnchinTitle"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.kihonUnchinShukeiKbn"
                        ref="kihonUnchinShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">高速代（内税）</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.hiwayPriceShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.hiwayPriceTitle"
                        ref="hiwayPriceTitle"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.hiwayPriceShukeiKbn"
                        ref="hiwayPriceShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">時間割増金額（課税）</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.jikanWarimashiKingakuShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.jikanWarimashiKingakuTitle"
                        ref="jikanWarimashiKingakuTitle"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.jikanWarimashiKingakuShukeiKbn"
                        ref="jikanWarimashiKingakuShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">距離割増金額（課税）</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.kyoriWarimashiKingakuShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.kyoriWarimashiKingakuTitle"
                        ref="kyoriWarimashiKingakuTitle"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.kyoriWarimashiKingakuShukeiKbn"
                        ref="kyoriWarimashiKingakuShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">係数割増金額（課税）</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.keisuWarimashiKingakuShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.keisuWarimashiKingakuTitle"
                        ref="keisuWarimashiKingakuTitle"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.keisuWarimashiKingakuShukeiKbn"
                        ref="keisuWarimashiKingakuShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">燃料割増金額（課税）</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.nenryoWarimashiKingakuShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.nenryoWarimashiKingakuTitle"
                        ref="nenryoWarimashiKingakuTitle"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.nenryoWarimashiKingakuShukeiKbn"
                        ref="nenryoWarimashiKingakuShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

            </v-tab-item>
            <v-tab-item value="tab2">
              <p style="white-space:pre-wrap;"></p>
              <!-- 見出し行 -->
              <v-row no-gutters align-content="center" style="color:#1F2B38;background-color:#E3E3E3;">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">定義名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">使用判断</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">表示名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">集計区分</span></v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）１</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei1ShiyoFlg"
                        :readonly="isReadOnlyKazei1"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei1Title"
                        ref="userKingakuKazei1Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei1ShukeiKbn"
                        ref="userKingakuKazei1ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei2">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）２</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei2ShiyoFlg"
                        :readonly="isReadOnlyKazei2"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei2Title"
                        ref="userKingakuKazei2Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei2ShukeiKbn"
                        ref="userKingakuKazei2ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei3">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）３</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei3ShiyoFlg"
                        :readonly="isReadOnlyKazei3"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei3Title"
                        ref="userKingakuKazei3Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei3ShukeiKbn"
                        ref="userKingakuKazei3ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei4">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）４</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei4ShiyoFlg"
                        :readonly="isReadOnlyKazei4"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei4Title"
                        ref="userKingakuKazei4Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei4ShukeiKbn"
                        ref="userKingakuKazei4ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei5">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）５</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei5ShiyoFlg"
                        :readonly="isReadOnlyKazei5"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei5Title"
                        ref="userKingakuKazei5Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei5ShukeiKbn"
                        ref="userKingakuKazei5ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei6">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）６</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei6ShiyoFlg"
                        :readonly="isReadOnlyKazei6"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei6Title"
                        ref="userKingakuKazei6Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei6ShukeiKbn"
                        ref="userKingakuKazei6ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei7">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）７</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei7ShiyoFlg"
                        :readonly="isReadOnlyKazei7"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei7Title"
                        ref="userKingakuKazei7Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei7ShukeiKbn"
                        ref="userKingakuKazei7ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei8">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）８</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei8ShiyoFlg"
                        :readonly="isReadOnlyKazei8"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei8Title"
                        ref="userKingakuKazei8Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei8ShukeiKbn"
                        ref="userKingakuKazei8ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei9">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）９</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei9ShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei9Title"
                        ref="userKingakuKazei9Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei9ShukeiKbn"
                        ref="userKingakuKazei9ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowKazei10">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（課税）１０</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuKazei10ShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuKazei10Title"
                        ref="userKingakuKazei10Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuKazei10ShukeiKbn"
                        ref="userKingakuKazei10ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

            </v-tab-item>
            <v-tab-item value="tab3">
              <p style="white-space:pre-wrap;"></p>
              <!-- 見出し行 -->
              <v-row no-gutters align-content="center" style="color:#1F2B38;background-color:#E3E3E3;">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">定義名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">使用判断</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">表示名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">集計区分</span></v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）１</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei1ShiyoFlg"
                        :readonly="isReadOnlyHikazei1"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei1Title"
                        ref="userKingakuHikazei1Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei1ShukeiKbn"
                        ref="userKingakuHikazei1ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei2">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）２</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei2ShiyoFlg"
                        :readonly="isReadOnlyHikazei2"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei2Title"
                        ref="userKingakuHikazei2Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei2ShukeiKbn"
                        ref="userKingakuHikazei2ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei3">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）３</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei3ShiyoFlg"
                        :readonly="isReadOnlyHikazei3"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei3Title"
                        ref="userKingakuHikazei3Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei3ShukeiKbn"
                        ref="userKingakuHikazei3ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei4">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）４</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei4ShiyoFlg"
                        :readonly="isReadOnlyHikazei4"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei4Title"
                        ref="userKingakuHikazei4Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei4ShukeiKbn"
                        ref="userKingakuHikazei4ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei5">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）５</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei5ShiyoFlg"
                        :readonly="isReadOnlyHikazei5"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei5Title"
                        ref="userKingakuHikazei5Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei5ShukeiKbn"
                        ref="userKingakuHikazei5ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei6">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）６</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei6ShiyoFlg"
                        :readonly="isReadOnlyHikazei6"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei6Title"
                        ref="userKingakuHikazei6Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei6ShukeiKbn"
                        ref="userKingakuHikazei6ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei7">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）７</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei7ShiyoFlg"
                        :readonly="isReadOnlyHikazei7"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei7Title"
                        ref="userKingakuHikazei7Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei7ShukeiKbn"
                        ref="userKingakuHikazei7ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei8">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）８</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei8ShiyoFlg"
                        :readonly="isReadOnlyHikazei8"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei8Title"
                        ref="userKingakuHikazei8Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei8ShukeiKbn"
                        ref="userKingakuHikazei8ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei9">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）９</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei9ShiyoFlg"
                        :readonly="isReadOnlyHikazei9"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei9Title"
                        ref="userKingakuHikazei9Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei9ShukeiKbn"
                        ref="userKingakuHikazei9ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHikazei10">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（非課税）１０</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuHikazei10ShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuHikazei10Title"
                        ref="userKingakuHikazei10Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuHikazei10ShukeiKbn"
                        ref="userKingakuHikazei10ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

            </v-tab-item>
            <v-tab-item value="tab4">
              <p style="white-space:pre-wrap;"></p>
              <!-- 見出し行 -->
              <v-row no-gutters align-content="center" style="color:#1F2B38;background-color:#E3E3E3;">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">定義名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">使用判断</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">表示名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">集計区分</span></v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）１</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei1ShiyoFlg"
                        :readonly="isReadOnlyUchizei1"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei1Title"
                        ref="userKingakuUchizei1Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei1ShukeiKbn"
                        ref="userKingakuUchizei1ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei2">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）２</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei2ShiyoFlg"
                        :readonly="isReadOnlyUchizei2"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei2Title"
                        ref="userKingakuUchizei2Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei2ShukeiKbn"
                        ref="userKingakuUchizei2ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei3">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）３</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei3ShiyoFlg"
                        :readonly="isReadOnlyUchizei3"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei3Title"
                        ref="userKingakuUchizei3Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei3ShukeiKbn"
                        ref="userKingakuUchizei3ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei4">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）４</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei4ShiyoFlg"
                        :readonly="isReadOnlyUchizei4"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei4Title"
                        ref="userKingakuUchizei4Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei4ShukeiKbn"
                        ref="userKingakuUchizei4ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei5">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）５</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei5ShiyoFlg"
                        :readonly="isReadOnlyUchizei5"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei5Title"
                        ref="userKingakuUchizei5Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei5ShukeiKbn"
                        ref="userKingakuUchizei5ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei6">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）６</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei6ShiyoFlg"
                        :readonly="isReadOnlyUchizei6"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei6Title"
                        ref="userKingakuUchizei6Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei6ShukeiKbn"
                        ref="userKingakuUchizei6ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei7">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）７</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei7ShiyoFlg"
                        :readonly="isReadOnlyUchizei7"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei7Title"
                        ref="userKingakuUchizei7Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei7ShukeiKbn"
                        ref="userKingakuUchizei7ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei8">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）8</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei8ShiyoFlg"
                        :readonly="isReadOnlyUchizei8"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei8Title"
                        ref="userKingakuUchizei8Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei8ShukeiKbn"
                        ref="userKingakuUchizei8ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei9">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）９</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei9ShiyoFlg"
                        :readonly="isReadOnlyUchizei9"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei9Title"
                        ref="userKingakuUchizei9Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei9ShukeiKbn"
                        ref="userKingakuUchizei9ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowUchizei10">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">ユーザ金額（内税）１０</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.userKingakuUchizei10ShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.userKingakuUchizei10Title"
                        ref="userKingakuUchizei10Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.userKingakuUchizei10ShukeiKbn"
                        ref="userKingakuUchizei10ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

            </v-tab-item>
            <v-tab-item value="tab5">
              <p style="white-space:pre-wrap;"></p>
              <!-- 見出し行 -->
              <v-row no-gutters align-content="center" style="color:#1F2B38;background-color:#E3E3E3;">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">定義名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">使用判断</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">表示名</span></v-col>
                    <v-col :cols=3 class="px-1"><span class="subtitle-2">集計区分</span></v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">汎用金額１</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.hanyoKingaku1ShiyoFlg"
                        :readonly="isReadOnlyHanyo1"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.hanyoKingaku1Title"
                        ref="hanyoKingaku1Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.hanyoKingaku1ShukeiKbn"
                        ref="hanyoKingaku1ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHanyo2">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">汎用金額２</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.hanyoKingaku2ShiyoFlg"
                        :readonly="isReadOnlyHanyo2"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.hanyoKingaku2Title"
                        ref="hanyoKingaku2Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.hanyoKingaku2ShukeiKbn"
                        ref="hanyoKingaku2ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHanyo3">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">汎用金額３</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.hanyoKingaku3ShiyoFlg"
                        :readonly="isReadOnlyHanyo3"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.hanyoKingaku3Title"
                        ref="hanyoKingaku3Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.hanyoKingaku3ShukeiKbn"
                        ref="hanyoKingaku3ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHanyo4">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">汎用金額４</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.hanyoKingaku4ShiyoFlg"
                        :readonly="isReadOnlyHanyo4"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.hanyoKingaku4Title"
                        ref="hanyoKingaku4Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.hanyoKingaku4ShukeiKbn"
                        ref="hanyoKingaku4ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row no-gutters align-content="center" v-show="isShowRowHanyo5">
                <v-col :cols=12>
                  <v-row no-gutters>
                    <v-col :cols=3 class="px-1 mt-1"><span class="text-black">汎用金額５</span></v-col>
                    <v-col :cols=3 class="px-1 mt-1">
                      <dd-switch
                        label="使用する"
                        v-model="kingakuConfig.hanyoKingaku5ShiyoFlg"
                        :readonly="readonly"
                      />
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-text-box
                        label=""
                        :noLabel="true"
                        v-model="kingakuConfig.hanyoKingaku5Title"
                        ref="hanyoKingaku5Title"
                        :readonly="readonly"
                        :length="50"
                        :valueType="Ctrls.InputTypes.Free"/>
                    </v-col>
                    <v-col :cols=3 class="px-1">
                      <dd-drop-down
                        label=""
                        v-model="kingakuConfig.hanyoKingaku5ShukeiKbn"
                        ref="hanyoKingaku5ShukeiKbn"
                        :readonly="readonly"
                        :items="kazeiKbnList"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <dd-custom-button :elevation="2" class="mx-5" color="#2F75B5" :minWidth="100" @click="onCloseClick">閉じる</dd-custom-button >
        <v-spacer></v-spacer>
        <dd-custom-button :elevation="2" class="mx-5" color="#2F75B5" :minWidth="100" @click="onSaveClick">反映</dd-custom-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdCustomButton from '@/components/DdCustomButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

const DdDropDown = () => import('@/components/DdDropDown')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'DdTorihikisakiKingakuDialog',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdDropDown,
    DdSwitch,
    DdTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 金額マスタ
     */
    kingaku: {},
    /**
     * readonly
     */
    readonly: Boolean
  },
  data: () => ({
    tab: 'tab1',
    kingakuConfig: {}
  }),
  created () {
  },
  mounted () {
    // 呼出元画面でマスタ情報は取得する為、ここでは不要
    // this.loadMasters()
  },
  computed: {
    ...mapGetters({
      kubunList: 'DDMasters/msysKubun'
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    kazeiKbnList () {
      const list = this.kubunList.filter((elem) => elem.kbnShuruiCd === 'KBN001')
        .map((elem) => {
          elem.value = elem.code.trim()
          elem.text = elem.codeNm.trim()
          return elem
        })
      list.unshift({ value: '', text: '' })
      return list
    },
    isReadOnlyKazei1 () {
      if (this.kingakuConfig.userKingakuKazei2ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei2 () {
      return this.kingakuConfig.userKingakuKazei1ShiyoFlg
    },
    isReadOnlyKazei2 () {
      if (this.kingakuConfig.userKingakuKazei3ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei3 () {
      return this.kingakuConfig.userKingakuKazei2ShiyoFlg
    },
    isReadOnlyKazei3 () {
      if (this.kingakuConfig.userKingakuKazei4ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei4 () {
      return this.kingakuConfig.userKingakuKazei3ShiyoFlg
    },
    isReadOnlyKazei4 () {
      if (this.kingakuConfig.userKingakuKazei5ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei5 () {
      return this.kingakuConfig.userKingakuKazei4ShiyoFlg
    },
    isReadOnlyKazei5 () {
      if (this.kingakuConfig.userKingakuKazei6ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei6 () {
      return this.kingakuConfig.userKingakuKazei5ShiyoFlg
    },
    isReadOnlyKazei6 () {
      if (this.kingakuConfig.userKingakuKazei7ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei7 () {
      return this.kingakuConfig.userKingakuKazei6ShiyoFlg
    },
    isReadOnlyKazei7 () {
      if (this.kingakuConfig.userKingakuKazei8ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei8 () {
      return this.kingakuConfig.userKingakuKazei7ShiyoFlg
    },
    isReadOnlyKazei8 () {
      if (this.kingakuConfig.userKingakuKazei9ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei9 () {
      return this.kingakuConfig.userKingakuKazei8ShiyoFlg
    },
    isReadOnlyKazei9 () {
      if (this.kingakuConfig.userKingakuKazei10ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowKazei10 () {
      return this.kingakuConfig.userKingakuKazei9ShiyoFlg
    },
    isReadOnlyHikazei1 () {
      if (this.kingakuConfig.userKingakuHikazei2ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei2 () {
      return this.kingakuConfig.userKingakuHikazei1ShiyoFlg
    },
    isReadOnlyHikazei2 () {
      if (this.kingakuConfig.userKingakuHikazei3ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei3 () {
      return this.kingakuConfig.userKingakuHikazei2ShiyoFlg
    },
    isReadOnlyHikazei3 () {
      if (this.kingakuConfig.userKingakuHikazei4ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei4 () {
      return this.kingakuConfig.userKingakuHikazei3ShiyoFlg
    },
    isReadOnlyHikazei4 () {
      if (this.kingakuConfig.userKingakuHikazei5ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei5 () {
      return this.kingakuConfig.userKingakuHikazei4ShiyoFlg
    },
    isReadOnlyHikazei5 () {
      if (this.kingakuConfig.userKingakuHikazei6ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei6 () {
      return this.kingakuConfig.userKingakuHikazei5ShiyoFlg
    },
    isReadOnlyHikazei6 () {
      if (this.kingakuConfig.userKingakuHikazei7ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei7 () {
      return this.kingakuConfig.userKingakuHikazei6ShiyoFlg
    },
    isReadOnlyHikazei7 () {
      if (this.kingakuConfig.userKingakuHikazei8ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei8 () {
      return this.kingakuConfig.userKingakuHikazei7ShiyoFlg
    },
    isReadOnlyHikazei8 () {
      if (this.kingakuConfig.userKingakuHikazei9ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei9 () {
      return this.kingakuConfig.userKingakuHikazei8ShiyoFlg
    },
    isReadOnlyHikazei9 () {
      if (this.kingakuConfig.userKingakuHikazei10ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHikazei10 () {
      return this.kingakuConfig.userKingakuHikazei9ShiyoFlg
    },
    isReadOnlyUchizei1 () {
      if (this.kingakuConfig.userKingakuUchizei2ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei2 () {
      return this.kingakuConfig.userKingakuUchizei1ShiyoFlg
    },
    isReadOnlyUchizei2 () {
      if (this.kingakuConfig.userKingakuUchizei3ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei3 () {
      return this.kingakuConfig.userKingakuUchizei2ShiyoFlg
    },
    isReadOnlyUchizei3 () {
      if (this.kingakuConfig.userKingakuUchizei4ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei4 () {
      return this.kingakuConfig.userKingakuUchizei3ShiyoFlg
    },
    isReadOnlyUchizei4 () {
      if (this.kingakuConfig.userKingakuUchizei5ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei5 () {
      return this.kingakuConfig.userKingakuUchizei4ShiyoFlg
    },
    isReadOnlyUchizei5 () {
      if (this.kingakuConfig.userKingakuUchizei6ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei6 () {
      return this.kingakuConfig.userKingakuUchizei5ShiyoFlg
    },
    isReadOnlyUchizei6 () {
      if (this.kingakuConfig.userKingakuUchizei7ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei7 () {
      return this.kingakuConfig.userKingakuUchizei6ShiyoFlg
    },
    isReadOnlyUchizei7 () {
      if (this.kingakuConfig.userKingakuUchizei8ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei8 () {
      return this.kingakuConfig.userKingakuUchizei7ShiyoFlg
    },
    isReadOnlyUchizei8 () {
      if (this.kingakuConfig.userKingakuUchizei9ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei9 () {
      return this.kingakuConfig.userKingakuUchizei8ShiyoFlg
    },
    isReadOnlyUchizei9 () {
      if (this.kingakuConfig.userKingakuUchizei10ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowUchizei10 () {
      return this.kingakuConfig.userKingakuUchizei9ShiyoFlg
    },
    isReadOnlyHanyo1 () {
      if (this.kingakuConfig.hanyoKingaku2ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHanyo2 () {
      return this.kingakuConfig.hanyoKingaku1ShiyoFlg
    },
    isReadOnlyHanyo2 () {
      if (this.kingakuConfig.hanyoKingaku3ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHanyo3 () {
      return this.kingakuConfig.hanyoKingaku2ShiyoFlg
    },
    isReadOnlyHanyo3 () {
      if (this.kingakuConfig.hanyoKingaku4ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHanyo4 () {
      return this.kingakuConfig.hanyoKingaku3ShiyoFlg
    },
    isReadOnlyHanyo4 () {
      if (this.kingakuConfig.hanyoKingaku5ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    },
    isShowRowHanyo5 () {
      return this.kingakuConfig.hanyoKingaku4ShiyoFlg
    },
    isReadOnlyHanyo5 () {
      if (this.kingakuConfig.hanyoKingaku6ShiyoFlg === true && this.readonly === false) {
        return true
      }
      return false
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.kingakuConfig = Object.assign({}, this.kingaku)
        this.tab = 'tab1'
      }
    }
  },
  methods: {
    loadMasters: function () {
      this.$store.dispatch('DDMasters/loadMasters', { list: ['msyskubun'], version: 1 }).then(() => {
      })
    },
    onCloseClick: function (e) {
      console.log('close clicked', this.kingakuConfig)
      this.$emit('close', this.kingaku)
    },
    onSaveClick: function (e) {
      console.log('close clicked', this.kingakuConfig)
      this.$emit('close', this.kingakuConfig)
    }
  }
}
</script>
<style scoped>
.description {
    text-align: left;
    font-family: YuGothic;
    font-size: 16px;
    letter-spacing: 0px;
    color: #2D71BF;
}
</style>
